import { Component, OnInit } from '@angular/core';
import {EmitterService} from '../../service/EmitterService';
import {AlertService} from '../../service/alert.service';
import * as moment from 'moment';
import {BlockService} from '../../service/BlockService';

@Component({
  selector: 'app-traitement-inco',
  templateUrl: './traitement-inco.component.html',
  styleUrls: ['./traitement-inco.component.css']
})
export class TraitementIncoComponent implements OnInit {
  agents = [];
  isFull = false;
  blocks = {};
  constructor(private emit: EmitterService, private alertService: AlertService, private blockservice: BlockService) {
    emit.getChangeEmitter().subscribe( teams => {
      this.agents = teams.members;
      this.agents.forEach((d, i) => {
        this.blocks[d.username] = {'break': null, date: null, debut_fin: []};
      })
    })
  }

  ngOnInit() {
  }
  getAgent(a) {
    return this.blocks[a.username]
  }
  getStartEnd(a) {
    return this.getAgent(a).debut_fin
  }
  addStartEnd(a) {
    const b = this.getAgent(a)
    if ( b.date != null && b.break !== null ) {
      this.blocks[a.username].debut_fin.push({start:'', end: ''})
    } else {
      this.alertService.error(`${a.lastName} ${a.firstName} [${a.username}] : s'il vous plait remplir tous les champs`, 0);
    }
  }
  save() {
    const keys = Object.keys(this.blocks)
    const data = []
    keys.forEach((dd, i) => {
      const d = this.blocks[dd]
        data.push(d.debut_fin.map((t, o) => {
          const el = { "matricule": dd, date: moment(d.date).format('DD/MM/YYYY'), "debut": this.insert(t.start, 2, ':'),
            "fin": this.insert(t.end, 2, ':'), "breakTemp": d.break };
          return el;
        }))
    })
    let _data = []
    data.forEach((d, i) => {
      _data = _data.concat(d)
    })

    this.blockservice.checkBreaksInco(_data).subscribe((data: any) => {
      const pdtrue   = []
      const pdfalse   = []
      data.forEach((d, i) => {
              if (Object.keys(d).indexOf('false') == -1) {
                pdtrue.push(d.true)
              }else{
                pdfalse.push(d.false)
              }
            })
     /* if ( pdtrue.length > 0){
        this.alertService.error('Des values déja exists', 0)
      }*/
      this.blockservice.putBreaksInco(pdfalse).subscribe(() => {
        if(pdfalse.length > 0 ) {
          this.alertService.success('Insertion avec succès', 0)
        }
        this.agents = []
      })
    })
  }
  insert(str, index, value) {
    return str.substr(0, index) + value + str.substr(index);
  }
  remove(a, i) {
    this.getAgent(a).debut_fin.splice(i, 1);;
  }
}



// WEBPACK FOOTER //
// ./src/app/view/traitement-inco/traitement-inco.component.ts